// Exports

export const colors = {
  // theme
  brandPrimary: '#851F82',
  brandPrimaryLight: '#FFF0EF',
  brandSecondary: '#4A62C9',
  brandSecondaryLight: '#6E81D4',
  grayDarker: '#404040',
  gray: '#909090',
  gray2: '#4F4F4F',
  grayLight: '#C0C0C0',
  grayLighter: '#EAEAEA',
  white: '#FFFFFF',
  white10: 'rgba(255, 255, 255, 0.1)',
  white20: 'rgba(255, 255, 255, 0.2)',
  white40: 'rgba(255, 255, 255, 0.4)',
  brandPrimary10: 'rgba(133, 31, 130, 0.1)',
  brandPrimary50: 'rgba(133, 31, 130, 0.5)',
  brandPrimary90: 'rgba(133, 31, 130, 0.9)',
  black80: 'rgba(0, 0, 0, 0.8)',
  black50: 'rgba(0, 0, 0, 0.5)',
  black25: 'rgba(0, 0, 0, 0.25)',
  black20: 'rgba(0, 0, 0, 0.20)',

  // rainbow
  rainbow0: '#B94BB6',
  rainbow1: '#8159C2',
  rainbow2: '#5E77E0',
  rainbow3: '#479ACE',
  rainbow4: '#F8B537',

  // semantic
  success: '#51E572',
  successLight: '#D0F9E6',
  alert: '#F74237',
  alertLight: '#FFEDEB',
  warning: '#F7C137'
}

export const shadow = {
  default: '0px 4px 4px rgba(0, 0, 0, 0.25)',
  card: '0px 4px 8px rgba(0, 0, 0, 0.25)',
  cardLg: '0px 8px 16px rgba(0, 0, 0, 0.25)',
  toast: '0 2px 8px rgba(0, 0, 0, 0.1)',
  dialogBox: '0 2px 8px rgba(0, 0, 0, 0.1)',
  quiz: '2px 5px 20px rgba(0, 0, 0, 0.12)',
  searchBar: '0px 8px 16px rgba(0, 0, 0, 0.25)',
  bottomSheet: '0 -4px 8px rgba(0, 0, 0, 0.25)'
}

export const fonts = {
  titleFamily: 'Ubuntu, sans-serif',
  textFamily: '"Open Sans", sans-serif'
}

export const student = {
  backgroundPrimary: 'linear-gradient(180deg, #8FC3F3 0%, #4A62C9 100%)',
  shadowPrimary: '#162C8A',
  backgroundSecondary: 'linear-gradient(180deg, #FFFFFF 0%, #E3E3E3 100%)',
  shadowSecondary: '#D1D1D1',
  backgroundGradient1: 'linear-gradient(180deg, #F6ACC2 0%, #B94BB6 100%)',
  backgroundGradient2: 'linear-gradient(180deg, #F8B8FA 0%, #8159C2 100%)',
  backgroundGradient3: 'linear-gradient(180deg, #9DD6E8 0%, #5E77E0 100%)',
  backgroundGradient4: 'linear-gradient(180deg, #A0F6F6 0%, #479ACE 100%)'
}
